module.exports = __webpack_public_path__ + "static/media/doc.a4bd33d4.svg";